import { withStyles } from '@mui/styles';
import { Modal, Backdrop, Fade } from '@mui/material';
import APHeading from "../../atoms/APHeading";
import APTimeoutProgress from "../../atoms/APTimeoutProgress";
import { withTranslate } from "../../../core/TenantProvider";
import APButton from '../../atoms/APButton';
import { connect } from 'react-redux';
import { Dispatch, bindActionCreators } from 'redux';
import { actions as SessionActions } from '../../../redux/modules/session';
import APFadeTimeoutModalStyles from "./styles/APFadeTimeoutModal.style";
import { useNavigate } from 'react-router-dom';

function APFadeTimeoutModal(props: any) {
    const { translate,
        pollingProgress,
        open,
        clearSession,
        handleClose,
        classes } = props;

    const navigate = useNavigate();

    return (
        <Modal
            aria-labelledby="Checking if client identity needed"
            aria-describedby="Checking if client identity needed"
            className={classes.modal}
            open={open}
            closeAfterTransition
            BackdropComponent={Backdrop}
            BackdropProps={{
                timeout: 500,
            }}
        >
            <Fade in={open}>
                <div className={classes.paper}>
                    <div className={classes.panel}>
                        <APHeading className={classes.modalHeader} variant="h4">
                            {translate('automated.timeout.modal.title')}<span className={classes.boldText}>{translate('automated.timeout.modal.title.boldtext')}</span>
                        </APHeading>
                        <p>{translate('automated.timeout.modal.paragraph')}</p>
                        <div className={classes.timeProgress}>
                            <APTimeoutProgress progress={pollingProgress} />
                        </div>
                        <div className={classes.buttonSection}>
                            <APButton
                                className={classes.logoutButton}
                                onClick={e => {
                                    clearSession(navigate);
                                }
                                }
                                variant="contained"
                            >
                                {translate('automated.timeout.modal.action.logout')}
                            </APButton>
                            <APButton
                                className={classes.continueButton}
                                variant="contained"
                                color="primary"
                                onClick={e => {
                                    e.preventDefault();
                                    handleClose();
                                }}
                            >
                                {translate('automated.timeout.modal.action.continue')}
                            </APButton>
                        </div>

                    </div>
                </div>
            </Fade>
        </Modal>
    );
}

const mapDispatchToProps = (dispatch: Dispatch) => bindActionCreators({
    clearSession: SessionActions.clearSession
}, dispatch);


export default (
    withTranslate(
        withStyles(APFadeTimeoutModalStyles)(
            connect(null, mapDispatchToProps)(APFadeTimeoutModal)
        )
    )
);